// extracted by mini-css-extract-plugin
export default {"debugTabs":"SiteDebugTools_debugTabs__lj0Zn","tabContent":"SiteDebugTools_tabContent__Jcg58","debugTabPane":"SiteDebugTools_debugTabPane__sRBKg"};